import { Select } from 'antd';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { FormItem } from '../FormItem';
import styles from '../Input/Input.module.scss';
import cn from 'classnames';
import { TLanguage } from '../../../types';
import { TOption } from '../MultySelect/MultySelect';

interface SelectI {
  name: string;
  label?: string;
  size?: SizeType;
  errorMessage?: string;
  options: TOption[];
  placeholder?: string;
  onChange?: any;
}

const { Option } = Select;

const CustomSelect = ({
  errorMessage,
  label = '',
  name,
  size = 'large',
  options,
  placeholder,
  onChange,
}: SelectI) => {
  return (
    <div className={cn(styles.wrapper, { [styles.wrapper_withLabel]: label })}>
      <div>{label}:</div>
      <FormItem message={errorMessage} name={name}>
        <Select options={options} placeholder={placeholder} onChange={onChange} allowClear>
          {options.map(item => (
            <Option key={item.label} value={item.value} size={size}>
              {item.label}
            </Option>
          ))}
        </Select>
      </FormItem>
    </div>
  );
};

export default CustomSelect;
